import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { updateAvailabilitySchema } from "@backend/src/schemas/AvailabilitySchema";

type UpdateAvailabilityResponseType = ResponseType<{
  userAvailabilityId: string,
      userId: string|null,
      reason: string,
      startDate: Date,
      endDate: Date | null,
      createdAt: Date,
      updatedAt: Date
}>;

function useUpdateAvailabilityMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<UpdateAvailabilityResponseType>["response"],
    AxiosResponseAndError<UpdateAvailabilityResponseType>["error"],
    z.infer<typeof updateAvailabilitySchema>
  >({
    mutationFn: (data) => {
    
      return ApiRequest.put<UpdateAvailabilityResponseType>(
        requestURLs.availability,
        data
      );
    },
  });

  return mutation;
}

export default useUpdateAvailabilityMutation;
